import { render, staticRenderFns } from "./GClassManagementGroupingProposalConfirm.vue?vue&type=template&id=432730f0&scoped=true&"
import script from "./GClassManagementGroupingProposalConfirm.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementGroupingProposalConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./GClassManagementGroupingProposalConfirm.vue?vue&type=style&index=0&id=432730f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432730f0",
  null
  
)

export default component.exports